import { Translate } from "components/common/Translate/Translate";
import { useDelete } from "./useDelete";

export interface IDeleteProps {
    handleClose: () => void;
}

export const Delete = ({ handleClose }: IDeleteProps) => {
    const { handleDelete } = useDelete();

    return (
        <div className="flex flex-col items-center py-4" onClick={(e) => e.stopPropagation()}>
            <div className="text-center capitalize text-2xl mb-8">
                <Translate keyName="delete-all-images" />?
            </div>
            <div
                className="w-full text-xl bg-irRed-400 text-white py-2 text-center capitalize rounded-xl mb-4 font-semibold"
                data-testid={`compressor-delete-all-yes`}
                onClick={() => {
                    handleDelete();
                    handleClose();
                }}
            >
                <Translate keyName="yes" />
            </div>
            <div
                className="w-full text-xl bg-irGray-200 dark:bg-darkSurface-400 py-2 text-center capitalize rounded-xl mb-4"
                data-testid={`compressor-delete-all-no`}
                onClick={handleClose}
            >
                <Translate keyName="no" />
            </div>
        </div>
    );
};
